import { useParams } from "react-router-dom";
import { useGetOne } from "react-admin";
import { LoadingIndicator } from "../LoadingIndicator";
import { AutovioCalendarEvent } from "../../model/autovioCalendarEvents";
import { useNavigate } from "react-router";
import { useEffect } from "react";

export function CalendarEventDispatcher() {
  const { calendarEventId } = useParams();
  const { data: calendarEvent } = useGetOne<AutovioCalendarEvent>(
    "calendarEvents",
    { id: calendarEventId ?? "" },
    { enabled: !!calendarEventId },
  );
  const navigate = useNavigate();
  useEffect(() => {
    if (calendarEvent) {
      const { type, drivingLessonType, drivingSchoolId, instructorId, vehicleId, start } = calendarEvent;
      let calendarUrl: string | undefined;
      if (type === "TheoryLesson" || type === "ASFCourseSession") {
        // Open courses calendar ...
        calendarUrl = `/drivingSchools/${drivingSchoolId}/courses-calendar?openDialog=${type}Dialog!${calendarEventId}`;
      } else if (type === "TheoryExam") {
        // Open exams calendar ...
        calendarUrl = `/drivingSchools/${drivingSchoolId}/exams-calendar?openDialog=${type}Dialog!${calendarEventId}`;
      } else if (type === "DrivingLesson" && drivingLessonType === "simulator") {
        // Open simulator calendar ...
        calendarUrl = `/simulators/${vehicleId}?openDialog=DrivingLessonDialog!${calendarEventId}`;
      } else if (type === "VehicleEvent" && vehicleId) {
        // Open vehicle calendar ...
        calendarUrl = `/vehicles/${vehicleId}?openDialog=VehicleEventDialog!${calendarEventId}`;
      } else if (instructorId) {
        // Open instructor calendar ...
        calendarUrl = `/instructors/${instructorId}?openDialog=${type}Dialog!${calendarEventId}`;
      } else {
        console.error(`Don't know how to open calendar event ${calendarEventId} of type ${type}`);
      }
      if (calendarUrl) {
        navigate(`${calendarUrl}#${start.toISODate()}`, { replace: true });
      }
    }
  }, [calendarEvent]);

  if (!calendarEvent) {
    return <LoadingIndicator />;
  }
  return null;
}
